import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "niota-state-config"
  }, [!_vm.templateContext ? _c('p', {
    staticClass: "card-description my-0"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.incomingwebhook.selectText')) + "\n  ")]) : _vm._e(), !_vm.templateContext ? _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.incomingwebhook.deviceIdentifier'),
      "autocomplete": "off",
      "hide-details": "auto",
      "data-cy": "device_identifier"
    },
    model: {
      value: _vm.deviceIdentifier,
      callback: function ($$v) {
        _vm.deviceIdentifier = $$v;
      },
      expression: "deviceIdentifier"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.incomingwebhook.packetVariable'),
      "autocomplete": "off",
      "hide-details": "auto",
      "clearable": "",
      "data-cy": "packet_variable"
    },
    model: {
      value: _vm.parsedPacketVariable,
      callback: function ($$v) {
        _vm.parsedPacketVariable = $$v;
      },
      expression: "parsedPacketVariable"
    }
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };